import { render, staticRenderFns } from "./RealTimeAlarm.vue?vue&type=template&id=a704660e&scoped=true&"
import script from "./RealTimeAlarm.vue?vue&type=script&lang=js&"
export * from "./RealTimeAlarm.vue?vue&type=script&lang=js&"
import style0 from "./RealTimeAlarm.vue?vue&type=style&index=0&id=a704660e&prod&scoped=true&lang=css&"
import style1 from "./RealTimeAlarm.vue?vue&type=style&index=1&id=a704660e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a704660e",
  null
  
)

export default component.exports